var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowthpayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12.4123,
    fill: "#4928FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 26.5001L23.6426 31.3212C23.7737 31.3868 23.8393 31.4196 23.9081 31.4325C23.9691 31.4439 24.0316 31.4439 24.0925 31.4325C24.1613 31.4196 24.2269 31.3868 24.3581 31.3212L34.0003 26.5001M14.0003 21.5001L23.6426 16.679C23.7737 16.6134 23.8393 16.5806 23.9081 16.5677C23.9691 16.5562 24.0316 16.5562 24.0925 16.5677C24.1613 16.5806 24.2269 16.6134 24.3581 16.679L34.0003 21.5001L24.3581 26.3212C24.2269 26.3868 24.1613 26.4196 24.0925 26.4325C24.0316 26.4439 23.9691 26.4439 23.9081 26.4325C23.8393 26.4196 23.7737 26.3868 23.6426 26.3212L14.0003 21.5001Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthpayment);
export default __webpack_public_path__ + "static/media/growthpayment.7575550d36bb2916649a3d0c468ae384.svg";
export { ForwardRef as ReactComponent };